export const getDaysInMonth = (m, y) => {
  return m === 2
    ? !(y % 4 || (!(y % 100) && y % 400))
      ? 29
      : 28
    : 30 + ((m + (m >> 3)) & 1);
};

export const downloadFile = ({ blob, fileUrl, textFileName }) => {
  const href = blob ? window.URL.createObjectURL(blob) : fileUrl;

  const anchor = document.createElement("a");
  anchor.setAttribute("href", href);
  anchor.setAttribute("download", textFileName);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.parentNode.removeChild(anchor);
};
